<div class="ppl-mt20 p-4">
    <table class="table custom-font-size">
        <thead>
            <tr>
                <th style="background-color: #a8e4e14d; width: 10%;">Code</th>
                <th style="background-color: #a8e4e14d; width: 10%;">Description</th>
                @if(!disabled) {
                <th style="background-color: #a8e4e14d; width: 10%;">Disposition</th>
                }
                <th style="background-color: #a8e4e14d; width: 10%;">Reason</th>
                <th style="background-color: #a8e4e14d; width: 10%;">Comment</th>
                @if(!isExternal) {
                <th style="background-color: #a8e4e14d; width: 10%;">Decision By</th>
                }
                <th style="background-color: #a8e4e14d; width: 10%;">Decision Date</th>

            </tr>
        </thead>
        <tbody >
            <tr *ngFor="let entry of deniedData; let i = index">
                <td >
                    <span>{{ entry.code }}</span>
                </td>
                <td >
                    <span>{{ entry.desc }}</span>
                </td>

                @if(!disabled) {
                <td >
                    <span>{{ entry.disposition }}</span>
                </td>
                }
                <td >
                    <span>{{ entry.reason }}</span>
                </td>

                <td >
                    <span>{{ entry.comments }}</span>
                </td>
                @if(!isExternal) {
                <td >
                    <span>{{ entry.decisionBy }}</span>
                </td>
                }
                <td >
                    <span>{{ entry.decisionDate }}</span>
                </td>
            </tr>
        </tbody>
    </table>
</div>